"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ViewRowColorService", {
    enumerable: true,
    get: function() {
        return ViewRowColorService;
    }
});
const _common = require("@nestjs/common");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
let ViewRowColorService = class ViewRowColorService {
    async getByViewId(_params) {
        return null;
    }
    async addRowColoringCondition(_params) {
        return null;
    }
    async updateRowColoringCondition(_params) {}
    async deleteRowColoringCondition(_params) {}
    async setRowColoringSelect(_params) {}
    async removeRowColorInfo(_params) {}
    async checkIfColumnInvolved(_param) {
        return {
            applyRowColorInvolvement: async ()=>{}
        };
    }
};
ViewRowColorService = _ts_decorate([
    (0, _common.Injectable)()
], ViewRowColorService);
